import { Box, Container, Grid, Stack, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useEffect, useState } from 'react';
import { Controller, FormProvider, useForm } from 'react-hook-form';
import 'survey-core/survey.i18n.js';
import { Serializer, Action, Base, ComputedUpdater } from 'survey-core';
import 'survey-creator-core/survey-creator-core.i18n.js';
import { settings, localization, editorLocalization } from 'survey-creator-core';
import { SurveyCreator, SurveyCreatorComponent } from 'survey-creator-react';
import 'survey-core/defaultV2.css';
import 'survey-creator-core/survey-creator-core.css';
import './index.css';
import { ReactElementFactory } from 'survey-react-ui';
import { getAllRtrTemplate } from 'wisestep-api';
import {
  WsButton,
  WsTypography,
  WsTypoColors,
  WsSelect,
  WsTypoVariants,
  WsSelectObj,
} from 'wisestep-base';

import { useWorkspaceContext } from '../../context/WorkspaceContext';
import { rtrAmplitudeEvents } from '../../features/conversationWidget/utils/rtrHelper';
import { warning, success } from '../../utils/NotificationMessages';
import { useNotificationStore } from '../../utils/NotificationStore';

let CategoryTemplateName = '',
  CategoryPropsData: any = '';

interface CategoryTemplateProps {
  CategoryTemplateNameProps?: any;
}
const useStyles = makeStyles({
  customButton: {
    textTransform: 'none',
    padding: '12px 24px',
    maxWidth: '200px',
    whiteSpace: 'nowrap',
    lineHeight: '1.4',
  },
});
export const CategoryRequestContext: React.FC<CategoryTemplateProps> = (props) => {
  const classes = useStyles();
  const methods = useForm();
  const setNotification = useNotificationStore((state) => state.setNotification);

  useEffect(() => {
    if (CategoryPropsData === '') {
      CategoryPropsData = props.CategoryTemplateNameProps;
    }

    if (
      CategoryPropsData !== '' &&
      CategoryPropsData.getCategoryTemplateName !== '' &&
      CategoryTemplateName === ''
    ) {
      CategoryTemplateName = CategoryPropsData?.getCategoryTemplateName;
    }
  });

  const handleSaveForm = (data) => {
    CategoryTemplateName = data['categoryName'];
    setNotification(success('Associate Template Added/Updated'));
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSaveForm)}>
          <Container>
            {props.CategoryTemplateNameProps?.modeType === 2 ? (
              <>
                <Stack spacing={2} direction="row" alignItems="center" marginTop={4} marginLeft={2}>
                  <WsTypography
                    variant={WsTypoVariants.SUB_TITLE}
                    bold
                    color={WsTypoColors.PRIMARY}
                  >
                    Selected Category name:
                  </WsTypography>
                  <Box>
                    <WsTypography cursor="pointer">
                      {props.CategoryTemplateNameProps.getCategoryTemplateName ||
                        CategoryTemplateName}
                    </WsTypography>
                  </Box>
                </Stack>
              </>
            ) : (
              <>
                <Box style={{ marginTop: '40px', marginLeft: '40px' }}>
                  <Grid container spacing={8} alignItems="center">
                    <Grid item xs={12} md={8}>
                      <Controller
                        name="categoryName"
                        control={methods.control}
                        defaultValue={
                          CategoryTemplateName ||
                          props.CategoryTemplateNameProps?.getCategoryTemplateName
                        }
                        render={({ field }) => (
                          <TextField
                            {...field}
                            fullWidth
                            variant="outlined"
                            label="Category name"
                          />
                        )}
                      />
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Stack direction="row" justifyContent="flex-end" spacing={2}>
                        <Grid item>
                          <WsButton
                            type="submit"
                            variant="contained"
                            className={classes.customButton}
                          >
                            {props.CategoryTemplateNameProps?.modeType === 1
                              ? 'EDIT Category '
                              : 'ADD Category '}
                          </WsButton>
                        </Grid>
                      </Stack>
                    </Grid>
                  </Grid>
                </Box>
              </>
            )}
          </Container>
        </form>
      </FormProvider>
    </>
  );
};

let RTRTemplateName = '',
  RTRResponseField = '',
  RTRStatus = '',
  RTRResponseField2 = '',
  RTRStatus2 = '';

interface RTRTemplateNameProps {
  RTRTemplateNameData?: any;
  RTRResponseFieldData?: any;
  RTRStatusData?: any;
  RTRResponseField2Data?: any;
  RTRStatus2Data?: any;
}

export const RtrTemplateContext: React.FC<RTRTemplateNameProps> = (props) => {
  const [templateDataList, setTemplateDataList] = useState<WsSelectObj[]>([]);
  const setNotification = useNotificationStore((state) => state.setNotification);
  const methods = useForm();
  const workspace = useWorkspaceContext();

  useEffect(() => {
    RTRTemplateName = '';
    RTRResponseField = '';
    RTRStatus = '';
    RTRResponseField2 = '';
    RTRStatus2 = '';
    const fetchData = async () => {
      try {
        const response = await getAllRtrTemplate(0, 25, '', 'templateName', 'asc');
        const namesArray: WsSelectObj[] = response.data.content?.map((item) => ({
          label: `${item.templateName}`,
          value: `${item.templateName}`,
        }));
        setTemplateDataList(namesArray);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };
    fetchData();
  }, []);

  const handleSave = (data) => {
    if (!data['rtrName']) {
      setNotification(warning('Please fill in the RTR Template field'));
      return;
    }

    setNotification(success('RTR Template Added/Updated'));
    rtrAmplitudeEvents('rtr_info_req', 'RTR template added/updated', workspace);
    RTRTemplateName = data['rtrName'];
    RTRResponseField = data['responseField'];
    RTRStatus = data['rtrStatus'];
    RTRResponseField2 = data['responseField2'];
    RTRStatus2 = data['rtrStatus2'];
  };

  const handleRemove = () => {
    RTRTemplateName = '';
    RTRResponseField = '';
    RTRStatus = '';
    RTRResponseField2 = '';
    RTRStatus2 = '';
    methods.setValue('rtrName', '');
  };

  return (
    <>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(handleSave)}>
          <Container>
            {props.RTRTemplateNameData?.modeType === 2 ? (
              <>
                <Grid container spacing={2} alignItems="center" marginTop={2}>
                  <Grid item xs={12} marginTop={2}>
                    <WsTypography variant={WsTypoVariants.SUB_TITLE} bold cursor="pointer">
                      Selected RTR template associated with Information Request Template
                    </WsTypography>
                  </Grid>
                  <Grid item xs={4}>
                    <Controller
                      name="rtrName"
                      control={methods.control}
                      defaultValue={props.RTRTemplateNameData?.getRTRTemplateName || ''}
                      render={({ field }) => (
                        <TextField
                          {...field}
                          fullWidth
                          variant="outlined"
                          label="RTR Template"
                          InputProps={{
                            readOnly: true,
                          }}
                        />
                      )}
                    />
                  </Grid>
                </Grid>
              </>
            ) : (
              <>
                <Grid container spacing={2} alignItems="center" marginTop={2}>
                  <Grid item xs={12} marginTop={2}>
                    <WsTypography variant={WsTypoVariants.SUB_TITLE} bold cursor="pointer">
                      Select an RTR template to be associated with Information Request Template
                    </WsTypography>
                  </Grid>
                  <Grid item xs={4}>
                    <Controller
                      name="rtrName"
                      control={methods.control}
                      defaultValue={props.RTRTemplateNameData?.getRTRTemplateName || ''}
                      render={({ field }) => (
                        <WsSelect
                          {...field}
                          selectArray={templateDataList}
                          placeholder="RTR Template"
                          size="medium"
                        />
                      )}
                    />
                  </Grid>
                </Grid>
                <Stack mt={2} direction="row" justifyContent="flex-end" spacing={2}>
                  <Grid item>
                    <WsButton type="button" variant="outlined" onClick={handleRemove}>
                      Remove RTR
                    </WsButton>
                  </Grid>
                  <Grid item>
                    <WsButton type="submit" variant="contained">
                      Associate RTR
                    </WsButton>
                  </Grid>
                </Stack>
              </>
            )}
          </Container>
        </form>
      </FormProvider>
    </>
  );
};

interface SurveyCreatorRenderComponentProps {
  modeType: number;
  jsonObject: any;
  categoryId: any;
  backTocategory: () => void;
  addGetDataBack: (body: any) => void;
  updateGetDataBack: (body: any) => void;
  toggleState: boolean;
  getRTRTemplateName: string;
  getRTRResponseField: string;
  getRTRStatus: string;
  getRTRResponseField2: string;
  getRTRStatus2: string;
  getCategoryTemplateName: string;
  getPageCount?: string;
}

const SurveyCreatorRenderComponent: React.FC<SurveyCreatorRenderComponentProps> = (props) => {
  ReactElementFactory.Instance.registerElement('svc-tab-template', () => {
    return React.createElement(RtrTemplateContext, {
      RTRTemplateNameData: props,
      RTRResponseFieldData: props,
      RTRStatusData: props,
      RTRResponseField2Data: props,
      RTRStatus2Data: props,
    });
  });

  ReactElementFactory.Instance.registerElement('svc-tab-template1', () => {
    return React.createElement(CategoryRequestContext, {
      CategoryTemplateNameProps: props,
    });
  });

  const setNotification = useNotificationStore((state) => state.setNotification);

  let svJsonObject: any = null;
  let sJsonObject = props.jsonObject;
  let sModeType = props.modeType;
  let scategoryId = props.categoryId;
  let isShowDesginer = true;
  const sRTRResponseField = props.getRTRResponseField;
  const sRTRStatus = props.getRTRStatus;
  const sRTRResponseField2 = props.getRTRResponseField2;
  const sRTRStatus2 = props.getRTRStatus2;
  const sGetAssociateTemplateName = props.getCategoryTemplateName;
  const sPageCount = props.getPageCount;

  settings.propertyGrid.maximumRateValues = 10;

  settings.toolbox.defaultJSON['rating'] = {
    displayMode: 'buttons',
    rateValues: [
      { value: 1, text: 'Extremely poor' },
      { value: 2, text: 'Poor' },
      { value: 3, text: 'Good' },
      { value: 4, text: 'Very good' },
      { value: 5, text: 'Excellent' },
    ],
  };

  Serializer.getProperty('rating', 'rateType').defaultValue = 'none';
  Serializer.getProperty('rating', 'rateType').visible = true;
  Serializer.getProperty('rating', 'rateCount').visible = false;
  Serializer.getProperty('rating', 'autoGenerate').defaultValue = true;
  Serializer.getProperty('rating', 'autoGenerate').visible = false;

  isShowDesginer = sModeType === 2 ? false : true;

  const options = {
    showLogicTab: false,
    showPanelBaseTab: false,
    showJSONEditorTab: false,
    showDesignerTab: isShowDesginer,
    toolboxLocation: 'none',
    questionTypes: [
      'text',
      'checkbox',
      'radiogroup',
      'dropdown',
      'rating',
      'file',
      'tagbox',
      'signaturepad',
      'comment',
      'boolean',
    ],
  };

  const creator = new SurveyCreator(options);
  if (sModeType === 1 || sModeType == 2) {
    creator.JSON = sJsonObject;
  }
  creator.pageEditMode = 'bypage';
  creator.toolbox.forceCompact = true;
  creator.showSidebar = false;
  const rateTypeProp = Serializer.getProperty('rating', 'rateType');
  rateTypeProp.setChoices(['labels', 'stars']);

  const translation = localization.getLocale();
  translation.pv.rateType.labels = 'Semantic';

  creator.onDefineElementMenuItems.add((_, options) => {
    const question = options.obj;
    if (question.getType() === 'rating') {
      const indexToRemove = options.items.findIndex((item) => item.id === 'settings');
      if (indexToRemove !== -1) {
        options.items.splice(indexToRemove, 1);
      }
    }
  });

  const expandSettingsAction = creator.toolbar.actions.find(
    (action) => action.id === 'svd-grid-expand'
  );
  if (expandSettingsAction) {
    const index = creator.toolbar.actions.indexOf(expandSettingsAction);
    creator.toolbar.actions.splice(index, 1);
  }

  const settingsAction = creator.toolbar.actions.find((action) => action.id === 'svd-settings');
  if (settingsAction) {
    const index = creator.toolbar.actions.indexOf(settingsAction);
    creator.toolbar.actions.splice(index, 1);
  }

  const engLocale = localization.getLocale('en');
  engLocale.pe.surveyTitlePlaceholder = 'Template Title';

  const translation1 = editorLocalization.getLocale('');
  translation1.ed.surveyPlaceHolder = `Click on the 'Add Question' below to  start creating an Information Request template`;

  creator.allowEditSurveyTitle = true;
  creator.onModified.add((sender) => {
    svJsonObject = sender.text;
  });

  creator.onSetPropertyEditorOptions.add((sender, options) => {
    options.editorOptions.allowBatchEdit = false;
  });

  creator.onCollectionItemAllowOperations.add((sender, options) => {
    if (options.obj.getType() === 'rating') {
      options.allowEdit = false;
    }
  });

  const templatesPlugin = {
    activate: () => {},
    deactivate: () => {
      return true;
    },
    model: new Base(),
  };
  const templatesPlugin1 = {
    activate: () => {},
    deactivate: () => {
      return true;
    },
    model: new Base(),
  };

  creator.addPluginTab('templates', templatesPlugin, 'RTR Template', 'svc-tab-template', 3);
  creator.addPluginTab(
    'templates1',
    templatesPlugin1,
    'Information Request',
    'svc-tab-template1',
    0
  );
  creator.activeTab = 'templates1';

  creator.toolbar.actions.push(
    new Action({
      id: 'svd-back',
      title: 'Go to List',
      enabled: true,
      action: function () {
        sModeType = props.modeType;
        sJsonObject = null;
        scategoryId = null;
        RTRTemplateName = '';
        CategoryTemplateName = '';
        props.backTocategory();
        CategoryPropsData = '';
        CategoryTemplateName = '';
      },
    })
  );
  if (isShowDesginer) {
    const tabs = ['designer', 'test', 'templates', 'templates1'];

    creator.toolbar.actions.push(
      new Action({
        id: 'svd-back',
        title: 'Back',
        visible: new ComputedUpdater(
          () =>
            creator.activeTab === 'test' ||
            creator.activeTab === 'templates' ||
            creator.activeTab === 'designer'
        ),
        enabled: true,
        iconName: 'icon-arrowleft',
        action: () => {
          const currentIndex = tabs.indexOf(creator.activeTab);
          if (currentIndex > 0) {
            creator.activeTab = tabs[currentIndex - 1];
          } else {
            creator.activeTab = tabs[tabs.length - 1];
          }
        },
      })
    );
    creator.toolbarItems.push(
      new Action({
        id: 'next-button',
        iconName: 'icon-arrowright',
        title: 'Next',
        visible: new ComputedUpdater(
          () =>
            creator.activeTab === 'designer' ||
            creator.activeTab === 'test' ||
            creator.activeTab === 'templates1'
        ),
        enabled: true,
        action: () => {
          const currentIndex = tabs.indexOf(creator.activeTab);
          if (currentIndex < tabs.length - 1) {
            creator.activeTab = tabs[currentIndex + 1];
          } else {
            creator.activeTab = tabs[0];
          }
        },
      })
    );
    creator.toolbar.actions.push(
      new Action({
        id: 'svd-save',
        title: 'Save Template',
        visible: new ComputedUpdater(() => creator.activeTab === 'templates'),
        enabled: true,
        action: function () {
          const parsedJsonObject = JSON.parse(svJsonObject);
          let body = {
            category: null,
            categoryName: '',
            id: '',
            countOfInformation: '',
            active: props.toggleState,
            rtrTemplate: '',
            rtrOption1: '',
            rtrStatus1: '',
            rtrOption2: '',
            rtrStatus2: '',
          };
          try {
            if (sModeType === 0) {
              body = {
                category: parsedJsonObject !== null ? parsedJsonObject : {},
                categoryName: CategoryTemplateName,
                id: '',
                countOfInformation:
                  parsedJsonObject !== null
                    ? parsedJsonObject.pages
                        ?.reduce((sum, page) => sum + (page.elements?.length || 0), 0)
                        .toString() || '0'
                    : '0',
                active: props.toggleState,
                rtrTemplate: RTRTemplateName,
                rtrOption1: RTRResponseField,
                rtrStatus1: RTRStatus,
                rtrOption2: RTRResponseField2,
                rtrStatus2: RTRStatus2,
              };
              props.addGetDataBack(body);
              CategoryTemplateName = '';
              CategoryPropsData = '';
            } else {
              const editAssociate = props.jsonObject;
              body = {
                category: parsedJsonObject !== null ? parsedJsonObject : editAssociate,
                categoryName:
                  CategoryTemplateName !== '' ? CategoryTemplateName : sGetAssociateTemplateName,
                id: scategoryId,
                countOfInformation:
                  parsedJsonObject !== null
                    ? parsedJsonObject.pages
                        ?.reduce((sum, page) => sum + (page.elements?.length || 0), 0)
                        .toString() || '0'
                    : sPageCount,
                active: props.toggleState,
                rtrTemplate: RTRTemplateName,
                rtrOption1: RTRResponseField !== '' ? RTRResponseField : sRTRResponseField,
                rtrStatus1: RTRStatus !== '' ? RTRStatus : sRTRStatus,
                rtrOption2: RTRResponseField2 !== '' ? RTRResponseField2 : sRTRResponseField2,
                rtrStatus2: RTRStatus2 !== '' ? RTRStatus2 : sRTRStatus2,
              };
              props.updateGetDataBack(body);
              CategoryTemplateName = '';
              CategoryPropsData = '';
            }
          } catch (error) {
            console.log('error in survay ts file----->', error);
            setNotification(warning(`Oops, Required Field is missing`));
          }
        },
      })
    );
  }

  return <SurveyCreatorComponent creator={creator} />;
};
export { SurveyCreatorRenderComponent as SurveyInfo };
